/** Wavy outline of a flag of size w×h, hoist straight at x = 0. */
export function flutterPath(w: number, h: number): string {
  const steps = 6;
  const amp = (i: number) => (h * 0.07 * i) / steps; // calm at the hoist, livelier at the fly
  const top: string[] = [];
  const bottom: string[] = [];
  for (let i = 1; i <= steps; i++) {
    const x = (w * i) / steps;
    const dy = (i % 2 ? 1 : -1) * amp(i);
    top.push(`${x.toFixed(2)} ${dy.toFixed(2)}`);
    bottom.push(`${x.toFixed(2)} ${(h + dy).toFixed(2)}`);
  }
  return `M0 0L${top.join('L')}L${bottom.reverse().join('L')}L0 ${h}Z`;
}
